import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ChartersOverviewPage from './pages/charters/ChartersOverviewPage';
import SpearfishingOverviewPage from './pages/charters/SpearfishingOverviewPage';
import CatalinaPage from './pages/charters/CatalinaPage';
import SanClementePage from './pages/charters/SanClementePage';
import OpenBlueWaterPage from './pages/charters/OpenBlueWaterPage';
import KelpForestsPage from './pages/charters/KelpForestsPage';
import ReefsPage from './pages/charters/ReefsPage';
import SportfishingPage from './pages/charters/SportfishingPage';
import PrivateCharterPage from './pages/charters/PrivateCharterPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import BookingPage from './pages/BookingPage';
import NotFoundPage from './pages/NotFoundPage';
import GlobalStyles from './assets/styles/GlobalStyles';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <GlobalStyles />
      <MainLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/charters" element={<ChartersOverviewPage />} />
          <Route path="/charters/spearfishing" element={<SpearfishingOverviewPage />} />
          <Route path="/charters/spearfishing/catalina" element={<CatalinaPage />} />
          <Route path="/charters/spearfishing/san-clemente-island" element={<SanClementePage />} />
          <Route path="/charters/spearfishing/open-blue-water" element={<OpenBlueWaterPage />} />
          <Route path="/charters/spearfishing/kelp-forests" element={<KelpForestsPage />} />
          <Route path="/charters/spearfishing/reefs" element={<ReefsPage />} />
          <Route path="/charters/sportfishing" element={<SportfishingPage />} />
          <Route path="/charters/private" element={<PrivateCharterPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/book" element={<BookingPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </MainLayout>
    </Router>
  );
}

export default App;
